module.exports = "/images/msg-generic-black.svg?e4659af95f4162bb32ab776827d61d06";